import DataSource from './DataSource.js';


class Store {
	//constructor(datasource, client) {
	constructor(datasource) {
		this.sources = {};
		datasource.forEach(ctx => {
			this.sources[ctx.guid] = new DataSource(ctx);
			$(this.sources[ctx.guid]).on('filter', () => {
				this._onFilterChange.call();
			});
		});
		console.info(datasource);
	}

	onFilterChange(fn) {
		this._onFilterChange = fn;
		return this;
	}

	hasAnyFilter() {
		var keys = Object.keys(this.sources);
		var hasAnyFilter = keys.some(key => {
			if(this.sources[key].filters.length > 0) {
				return true;
			}
			else {
				return false;
			}
		});
		return hasAnyFilter;
	}


	resetFilter() {
		var keys = Object.keys(this.sources);
		keys.forEach(key => {
			if(this.sources[key].filters.length > 0) {
				this.sources[key].clearFilter();
			}
		});
	}

	createSource(ctx) {
		this.sources[ctx.guid] = new DataSource(ctx);
	}

	deleteSource(guid) {
		delete this.sources[guid];
	}
}

export default Store;


// WEBPACK FOOTER //
// ./resources/WEB-INF/src/data/Store.js